// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__RrNwv","col":"styles_col__OBHB3","fulfillmentStatus":"styles_fulfillmentStatus__3jrGS","emailCol":"styles_emailCol__30W9p"};